const isNil = (value) => value === null || value === undefined;
export default isNil;
